export default __webpack_public_path__ + "static/media/property_916.290ffdc6.png";